import { Navigate, Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import AssessmentView from "./assessment.view";

const useAssessmentRoutes = () => (
  <>
    <Route path={`${pages.assessment.path}/:tab`} element={<AssessmentView />} />
    <Route
      path={pages.assessment.path}
      element={<Navigate to={`${pages.assessment.path}/assessments`} replace />}
    />
  </>
);

export default useAssessmentRoutes;
